import type { NotificationsListResponse } from '@paladin-monorepo/common';
import API from '../api';

const PAGE_LIMIT = 5;
const PAGE_OFFSET = 0;

export const notificationsApi = {
  async list(includeRead: boolean): Promise<NotificationsListResponse> {
    const params = new URLSearchParams({
      limit: String(PAGE_LIMIT),
      offset: String(PAGE_OFFSET),
    });
    if (includeRead) {
      params.set('unread', 'false');
    }
    return API.get<NotificationsListResponse>(`/notifications?${params}`).then(
      (res) => res.data,
    );
  },

  async markAllRead(): Promise<void> {
    await API.post('/notifications/mark-all-read');
  },

  async markRead(notificationId: string): Promise<void> {
    await API.post(`/notifications/${encodeURIComponent(notificationId)}/mark-read`);
  },
};
